import React from "react";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import ContentLayout from "../ContentLayout";
import OfferPopup from "../OfferPopup";
import CopyIcon from "./../../../assets/Copy.svg";

const LearnToRedeem = () => {
  const redeemHelpLink =
    "https://support.bluestacks.com/hc/en-us/articles/4408768275213-How-to-redeem-a-Google-Play-gift-card-won-through-BlueStacks-5#%E2%80%9C1%E2%80%9D";

  return (
    <p className="text-sm text-muted-text">
      <a
        href={redeemHelpLink}
        target="_blank"
        rel="noreferrer"
        className="text-link-blue underline underline-offset-1 hover:text-sky-600"
      >
        <FormattedMessage id="giftCard.clickHere" />
      </a>{" "}
      <FormattedMessage
        id="giftCard.learnToRedeem"
        values={{ giftCardType: "Google Play" }}
      />
    </p>
  );
};

const CodeBox = ({ code, copyCode }) => (
  <div className="flex w-full items-center justify-around gap-7 rounded-md border-2 border-[#7FCC66] bg-white p-3">
    <span className="text-xl font-semibold text-code-color">{code}</span>
    <img
      className="cursor-pointer hover:scale-110"
      onClick={copyCode}
      src={CopyIcon}
      alt="copy"
    />
  </div>
);

function Code({ code, amount, showOfferPopup, enrollSurveyClick }) {
  const copyCode = () => {
    navigator.clipboard.writeText(code).then(() => {
      toast.success("Code Copied!");
    });
  };

  useEffect(() => {
    toast.success("Congratulations!");
  }, []);

  return (
    <ContentLayout>
      <h1 className="mt-2 text-3xl font-bold text-heading-color">
        <FormattedMessage
          id="giftCard.codeHeading"
          values={{ price: amount }}
        />
      </h1>
      <div className="flex w-[356px] flex-col items-center  gap-3 rounded-md bg-[#F3FFED] p-5 md:items-start">
        <h3 className="font-bold uppercase text-[#6DB346]">
          {`${amount} GIFT CARD CODE`}
        </h3>
        <CodeBox code={code} copyCode={copyCode} />
        <LearnToRedeem />
      </div>
          {showOfferPopup && <OfferPopup
              onClick={enrollSurveyClick}
          />}
      </ContentLayout>
  );
}

export default Code;
